import { Hbml } from "@holibob-packages/hbml";
import { isElementNodeOfType, isTextNode } from "@holibob-packages/hbml";

import { HbmlComponents } from "../../../components";
import { ProductContentEntryV2 } from "../../types";

export function normalizeProductContentToBulletedList(entries: ProductContentEntryV2[]) {
    const listItems = entries.flatMap((entry) => {
        return Array.from(extractListItemsFromProductContent(entry));
    });

    if (!listItems.length) {
        return [];
    }

    return [
        {
            type: HbmlComponents.HbmlElements.BULLETED_LIST,
            children: listItems,
        },
    ];
}

function* extractListItemsFromProductContent(productContent: ProductContentEntryV2) {
    if (productContent.name) {
        if (productContent.descriptionJson.length > 0) {
            yield {
                type: HbmlComponents.HbmlElements.LIST_ITEM,
                withMarker: !hasBulletedListAtRoot(productContent.descriptionJson),
                children: [
                    {
                        type: HbmlComponents.HbmlElements.LIST_ITEM_CONTENT,
                        children: [{ text: productContent.name, bold: true }, ...productContent.descriptionJson],
                    },
                ],
            };
        } else {
            yield {
                type: HbmlComponents.HbmlElements.LIST_ITEM,
                children: [
                    {
                        type: HbmlComponents.HbmlElements.LIST_ITEM_CONTENT,
                        children: [{ text: productContent.name }],
                    },
                ],
            };
        }
    } else {
        yield* extractListItemsFromContent(productContent.descriptionJson);
    }
}

function hasBulletedListAtRoot([firstChild]: Hbml) {
    return isElementNodeOfType(firstChild, HbmlComponents.HbmlElements.BULLETED_LIST);
}

function* extractListItemsFromContent(content: Hbml) {
    for (const item of content) {
        if (isTextNode(item)) {
            yield {
                type: HbmlComponents.HbmlElements.LIST_ITEM,
                children: [
                    {
                        type: HbmlComponents.HbmlElements.LIST_ITEM_CONTENT,
                        children: [item],
                    },
                ],
            };
        }

        if (isElementNodeOfType(item, HbmlComponents.HbmlElements.PARAGRAPH)) {
            yield {
                type: HbmlComponents.HbmlElements.LIST_ITEM,
                children: [
                    {
                        type: HbmlComponents.HbmlElements.LIST_ITEM_CONTENT,
                        children: item.children,
                    },
                ],
            };
        }

        if (
            isElementNodeOfType(item, HbmlComponents.HbmlElements.BULLETED_LIST) ||
            isElementNodeOfType(item, HbmlComponents.HbmlElements.NUMBERED_LIST)
        ) {
            yield* item.children;
        }
    }
}
